import PrimaryButton from "canbook-style/ui/button/primary";
import { ButtonType } from "canbook-style/ui/button/models";
import ErrorPrompt from "canbook-style/ui/prompt/error";
import { EmailComponentCallback, useEmailState } from "../hooks";

export function EmailComponent({
  emailAddress,
  callback,
  onSwitchToPhone,
}: {
  emailAddress: string;
  callback: EmailComponentCallback;
  onSwitchToPhone: () => void;
}) {
  const {
    emailInputRef,
    errors,
    apiError,
    isInProgress,
    email,
    setEmail,
    setApiError,
    handleEmailSubmit,
    checkEmailValidation,
    isSubmittedOnce,
  } = useEmailState(emailAddress, callback);

  return (
    <div className="px-4 w-full mt-20 lg:mt-0 lg:w-1/2 xl:w-1/3 flex lg:items-center lg:justify-center">
      <div className="w-full sm:w-4/6 lg:w-3/4 mx-auto bg-surface flex flex-col gap-12">
        <h1 className="hidden lg:block d-header-1 text-font-primary">
          Sign up
        </h1>
        <div className="flex flex-col gap-10">
          <div className="w-full">
            <p className="header-2 text-font-primary">
              What's your email address?
            </p>
            <p className="body-2 text-font-secondary pt-1">
              A 6 digit OTP will be sent to your email for verification.
            </p>
          </div>
          <form
            className="flex flex-col w-full gap-10"
            onSubmit={handleEmailSubmit}
          >
            <div className="flex flex-col w-full">
              <label className="body-2 text-font-disabled lg:text-font-secondary pl-3 pb-2">
                Email address
              </label>
              <div className="flex relative w-full subheader-1">
                <input
                  aria-label="Email address"
                  type="email"
                  name="email"
                  className="border border-outline bg-container-low py-3 px-6 rounded-xl w-full text-font-primary outline-none focus:border-primary caret-primary"
                  onChange={(e) => {
                    const inputVal = e.target.value.trim();
                    setEmail(inputVal);
                    checkEmailValidation(inputVal);
                  }}
                  value={email}
                  autoComplete="email"
                  ref={emailInputRef}
                />
              </div>
              <div className="mt-1 error-message">
                {isSubmittedOnce &&
                  errors.find((error) => error.for == "email")?.message}
              </div>
            </div>
            <PrimaryButton
              type={ButtonType.submit}
              text="Get OTP"
              isExpanded={true}
              isDisabled={email == "" || errors.length > 0}
              isInProgress={isInProgress}
            />
          </form>
        </div>
        <div className="flex justify-center pb-6">
          <button
            type="button"
            className="body-2 text-font-secondary underline-offset-4 hover:text-font-primary focus-visible:outline-none"
            onClick={onSwitchToPhone}
          >
            Login with phone
          </button>
        </div>
        {apiError && (
          <ErrorPrompt error={apiError} onClose={() => setApiError(null)} />
        )}
      </div>
    </div>
  );
}

export default EmailComponent;
